import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import SettingsRowButton from 'settings-ui-lib/components/SettingsRowButton';
import SettingsRowWrapper from 'settings-ui-lib/components/SettingsRowWrapper';
import Subsection from 'settings-ui-lib/components/Subsection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { arePasskeysSupported } from '../utils/arePasskeysSupported';
import UIButton from 'UIComponents/button/UIButton';
import { useEffect, useState } from 'react';
import DeletePasskeyModal from './DeletePasskeyModal';
import RenamePasskeyModal from './RenamePasskeyModal';
// @ts-expect-error ts-migrate(2307)
import passkeyLogo from 'bender-url!../../images/passkey-logo-orange.svg';
import { parse } from 'hub-http/helpers/params';
import aaguids from '../../json/aaguids.json';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { View } from 'foundations-components/components/View';
import { trackPasskeySettingsSetupInitiated } from '../lib/tracker';
// @ts-expect-error ts-migrate(7016)
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { PASSKEYS_KB_URL } from '../constants/Passkeys';
import PasskeySetupOrSkipModal from './PasskeySetupOrSkipModal';
import WithReAuth from 'two-factor-prompt-lib/containers/WithReAuth';
import { redirect } from '../utils/redirect';
import I18n from 'I18n';
import { createLaboratoryClient } from '../common/laboratoryClient';
import { PASSKEY_GROUP_CONTROL, PASSKEY_GROUP_VARIATION, PASSKEY_NUDGE_EXPERIMENT_KEY } from '../constants/Experiments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MaxWidthSettingsRow = styled(SettingsRowWrapper).withConfig({
  displayName: "PasskeysSettings__MaxWidthSettingsRow",
  componentId: "sc-1hn4phj-0"
})(["max-width:600px;"]);
const PasskeysSettings = ({
  createPasskey,
  deletePasskey,
  renamePasskey,
  togglePasskeyDeleteModal,
  togglePasskeyRenameModal,
  passkeyCredentials,
  email,
  userId,
  fetchPasskeys,
  deletePasskeyError,
  renamePasskeyError,
  deletePasskeyModalOpen,
  renamePasskeyModalOpen,
  location,
  history,
  setupPasskeyFromNudge,
  showPasskeyNudge,
  passkeyRedirectUrl,
  fetchSsoSettings,
  isHubless,
  isUserImpersonated
}) => {
  const [passkeysSupported, setPasskeysSupported] = useState(false);
  const [variant, setVariant] = useState(PASSKEY_GROUP_CONTROL);
  useEffect(() => {
    /* eslint-disable-next-line promise/catch-or-return, @typescript-eslint/no-floating-promises */
    arePasskeysSupported().then(result => {
      setPasskeysSupported(result);
      const laboratoryClient = createLaboratoryClient(userId);
      try {
        laboratoryClient.resolve(treatment => {
          const {
            parameters: {
              group
            }
          } = treatment[PASSKEY_NUDGE_EXPERIMENT_KEY];
          setVariant(group);
          const {
            search
          } = location;
          const query = parse(search.substr(1));
          history.replace(Object.assign({}, location, {
            search: null,
            query: null
          }));
          if (query.setupPasskeyFromNudge) {
            const redirectUrl = Array.isArray(query.setupPasskeyFromNudge) ? query.setupPasskeyFromNudge[0] : query.setupPasskeyFromNudge;
            if (!result) {
              redirect(redirectUrl);
            } else {
              setupPasskeyFromNudge(redirectUrl);
            }
          }
        });
      } catch (e) {
        console.error('Error resolving laboratory client');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchPasskeys(userId);
    if (!isHubless) {
      fetchSsoSettings();
    }
  }, [fetchPasskeys, fetchSsoSettings, userId, isHubless]);
  const handleOnClick = () => {
    trackPasskeySettingsSetupInitiated();
    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
    createPasskey(email);
  };
  const [credentialIdToDelete, setCredentialIdToDelete] = useState('');
  const [credentialIdToRename, setCredentialIdToRename] = useState('');
  const handleOnDeletePasskey = credentialId => {
    deletePasskey(credentialId);
  };
  const handleOnRenamePasskey = (credentialId, name) => {
    renamePasskey(credentialId, name);
  };
  const disabled = !passkeysSupported || isUserImpersonated;
  const disabledReason = isUserImpersonated ? 'userPreferences.tooltips.userImpersonation' : 'userPreferences.passkeys.disabledReason';
  const renderPasskeySection = () => {
    if (passkeyCredentials.length === 0) {
      return /*#__PURE__*/_jsx(SettingsRowButton, {
        "data-test-id": "passkey-create-button",
        title: /*#__PURE__*/_jsx(WithReAuth, {
          onSuccess: handleOnClick,
          isDisabled: disabled,
          email: email,
          skipVerificationIfNotSet: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.passkeys.button"
          })
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.passkeys.description"
        }),
        disabled: disabled,
        disabledTooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: disabledReason
        })
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DeletePasskeyModal, {
        credentialId: credentialIdToDelete,
        email: email,
        open: deletePasskeyModalOpen,
        deletePasskey: handleOnDeletePasskey,
        deletePasskeyError: deletePasskeyError,
        hideModal: () => togglePasskeyDeleteModal()
      }), renamePasskeyModalOpen && /*#__PURE__*/_jsx(RenamePasskeyModal, {
        credentialId: credentialIdToRename,
        renamePasskey: handleOnRenamePasskey,
        renamePasskeyError: renamePasskeyError,
        hideModal: () => togglePasskeyRenameModal()
      }), /*#__PURE__*/_jsx(MaxWidthSettingsRow, {
        children: passkeyCredentials.map(credential => {
          var _credential$name, _passkeyData$icon_lig;
          const passkeyData = aaguids[credential.aaguid];
          const passkeyName = (_credential$name = credential.name) !== null && _credential$name !== void 0 ? _credential$name : passkeyData !== null && passkeyData !== void 0 && passkeyData.name ? I18n.text(`userPreferences.passkeys.provider.${passkeyData.name}`) : I18n.text('userPreferences.passkeys.fallbackName');
          return /*#__PURE__*/_jsx(UITile, {
            "data-test-id": `passkey-${credential.credentialId}`,
            compact: true,
            children: /*#__PURE__*/_jsx(UITileSection, {
              children: /*#__PURE__*/_jsxs(UIFlex, {
                align: "center",
                justify: "between",
                children: [/*#__PURE__*/_jsxs(UIFlex, {
                  gap: 12,
                  align: "center",
                  children: [/*#__PURE__*/_jsx("img", {
                    width: 32,
                    alt: passkeyName,
                    src: (_passkeyData$icon_lig = passkeyData === null || passkeyData === void 0 ? void 0 : passkeyData.icon_light) !== null && _passkeyData$icon_lig !== void 0 ? _passkeyData$icon_lig : passkeyLogo
                  }), /*#__PURE__*/_jsx(View, {
                    marginInlineEnd: "100",
                    as: "div",
                    children: passkeyName
                  })]
                }), /*#__PURE__*/_jsx(UIButton, {
                  size: "small",
                  "data-test-id": `passkey-rename-${credential.credentialId}`,
                  disabled: isUserImpersonated,
                  onClick: () => {
                    setCredentialIdToRename(credential.credentialId);
                    togglePasskeyRenameModal();
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "userPreferences.passkeys.rename"
                  })
                }), /*#__PURE__*/_jsx(UITooltip, {
                  title: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "userPreferences.tooltips.userImpersonation"
                  }),
                  disabled: !isUserImpersonated,
                  children: /*#__PURE__*/_jsx(UIButton, {
                    size: "small",
                    "data-test-id": `passkey-delete-${credential.credentialId}`,
                    use: "danger",
                    disabled: isUserImpersonated,
                    onClick: () => {
                      setCredentialIdToDelete(credential.credentialId);
                      togglePasskeyDeleteModal();
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "userPreferences.passkeys.delete"
                    })
                  })
                })]
              })
            })
          }, credential.credentialId);
        })
      }), /*#__PURE__*/_jsx(WithReAuth, {
        onSuccess: handleOnClick,
        isDisabled: disabled,
        email: email,
        skipVerificationIfNotSet: true,
        children: /*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: disabledReason
          }),
          disabled: !disabled,
          children: /*#__PURE__*/_jsx(UIButton, {
            size: "sm",
            disabled: disabled,
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "userPreferences.passkeys.addPasskeyButton"
            })
          })
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(Subsection, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.passkeys.title"
    }),
    children: [renderPasskeySection(), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      marginInlineStart: "0",
      display: "block",
      children: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: PASSKEYS_KB_URL
      })
    }), showPasskeyNudge && !disabled && /*#__PURE__*/_jsx(PasskeySetupOrSkipModal, {
      createPasskey: createPasskey,
      email: email,
      passkeyRedirectUrl: passkeyRedirectUrl,
      isVariant: variant === PASSKEY_GROUP_VARIATION
    })]
  });
};
export default PasskeysSettings;